import { useMutation } from '@apollo/client';
import { removeBehavioralAudienceInsightMutation } from 'api/mutations/customInsight';
import { EventTypes } from 'modules/domains/segmentation';

type DeleteCustomInsightResponse = {
  removeBehavioralAudienceInsight: { success: boolean };
};

type DeleteCustomInsightRequest = {
  eventName: string;
  dataType: EventTypes;
};

export const useDeleteCustomBehavioralInsight = () => {
  const [deleteBehavioralAudienceInsight, { data, loading, called, error }] = useMutation<
    DeleteCustomInsightResponse,
    DeleteCustomInsightRequest
  >(removeBehavioralAudienceInsightMutation);

  const deleteCustomBehavioralInsight = (eventName: string, dataType: EventTypes) => {
    deleteBehavioralAudienceInsight({ variables: { eventName, dataType } });
  };

  return {
    deleteCustomBehavioralInsight,
    data: data ?? null,
    isLoading: loading,
    isCalled: called,
    isSuccess: !loading && !!data?.removeBehavioralAudienceInsight.success,
    isError: !loading && (!data?.removeBehavioralAudienceInsight.success || !!error),
  };
};
